module.exports = __webpack_public_path__ + "img/chat-details4.dd0b939c.png";